// src/lib/fetch-patch.js
if (!window.__fetchPatched) {
  const originalFetch = window.fetch.bind(window);

  // Decide base URL once
  const ENV_BASE =
    process.env.REACT_APP_API_URL || // optional .env override
    (window.location.hostname === 'localhost'
      ? 'http://localhost:6000'
      : window.location.origin);

  const withBase = (url) => {
    if (typeof url !== 'string') return url;
    if (/^https?:\/\//i.test(url)) return url; // already absolute
    return ENV_BASE.replace(/\/+$/, '') + url;
  };

  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? withBase(input) : input;

    const res = await originalFetch(url, {
      credentials: 'include',
      ...init,
    });

    // 401: single-device session revoked
    if (res.status === 401) {
      const data = await res.clone().json().catch(() => ({}));
      if (data?.code === 'SESSION_REVOKED') {
        window.localStorage.setItem('session_revoked', '1');
        window.dispatchEvent(new CustomEvent('session:revoked'));
      }
    }

    // 403: subscription expired
    if (res.status === 403) {
      const data = await res.clone().json().catch(() => ({}));
      if (data?.code === 'SUBSCRIPTION_EXPIRED') {
        if (!window.location.pathname.startsWith('/subscribe')) {
          window.location.assign('/subscribe');
        }
      }
    }

    return res;
  };

  window.__fetchPatched = true;
}
